import React, { Fragment } from "react";
import EnquiresCheckBox from "./Checkbox";

const EnquireCheckBoxCollection = ({ data, type }) => {
  return (
    <>
      {data.map((item, i) => (
        <Fragment key={i}>
          {type === "checkbox" && (
            <EnquiresCheckBox
              idName={item.idName}
              labelTitle={item.labelTitle}
            />
          )}
        </Fragment>
      ))}
    </>
  );
};

export default EnquireCheckBoxCollection;
